module.exports = __webpack_public_path__ + "img/avatar.7c6c9593.png";